/* Orchard 2026 core: age gate, header drawer, rails, AJAX add, card toggles, flipper, flavor tents. Vanilla, deferred. */
(function () {
  'use strict';
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  /* ---------- money ---------- */
  function money(cents) {
    var fmt = (window.OrchardMoneyFormat || '${{amount}}');
    var v = (cents / 100);
    var withDec = v.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var noDec = Math.round(v).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt.replace(/\{\{\s*amount_no_decimals\s*\}\}/, noDec)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, v.toFixed(2).replace('.', ','))
      .replace(/\{\{\s*amount\s*\}\}/, withDec);
  }
  window.OrchardMoney = money;

  /* ---------- age gate (before any popup) ---------- */
  function ageOk() { document.documentElement.classList.add('o-age-ok'); document.dispatchEvent(new CustomEvent('orchard:age-ok')); }
  window.Orchard = window.Orchard || {};
  window.Orchard.ageVerified = function () { return document.documentElement.classList.contains('o-age-ok'); };
  var gate = document.querySelector('[data-o-age]');
  if (gate && !document.documentElement.classList.contains('o-age-ok')) {
    requestAnimationFrame(function () { setTimeout(function () { gate.classList.add('is-up'); }, 120); });
    var ask = gate.querySelector('[data-o-age-ask]'), under = gate.querySelector('[data-o-age-under]');
    var yes = gate.querySelector('[data-o-age-yes]');
    yes && yes.focus();
    gate.addEventListener('click', function (e) {
      if (e.target.closest('[data-o-age-yes]')) { try { localStorage.setItem('orchard_age_ok', '1'); } catch (x) {} ageOk(); }
      if (e.target.closest('[data-o-age-no]')) { ask.hidden = true; under.hidden = false; under.querySelector('button').focus(); }
      if (e.target.closest('[data-o-age-back]')) { under.hidden = true; ask.hidden = false; yes.focus(); }
    });
    gate.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab') return;
      var f = Array.prototype.filter.call(gate.querySelectorAll('button'), function (b) { return b.offsetParent !== null; });
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
  } else { document.dispatchEvent(new CustomEvent('orchard:age-ok')); }

  /* ---------- header drawer ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-o-burger]');
    if (!t) return;
    var d = document.getElementById(t.getAttribute('aria-controls'));
    var open = t.getAttribute('aria-expanded') !== 'true';
    t.setAttribute('aria-expanded', open); d && d.classList.toggle('is-open', open);
  });

  /* ---------- rails ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-o-rail]');
    if (!b) return;
    var rail = document.getElementById(b.getAttribute('aria-controls'));
    if (rail) rail.scrollBy({ left: Number(b.dataset.oRail) * rail.clientWidth * 0.8, behavior: 'smooth' });
  });

  /* ---------- AJAX cart (Dawn cart drawer + header count) ---------- */
  function cartAdd(items, btn) {
    var drawer = document.querySelector('cart-drawer');
    var body = { items: items };
    if (drawer) { body.sections = ['cart-drawer', 'cart-icon-bubble']; body.sections_url = window.location.pathname; }
    else { body.sections = ['cart-icon-bubble']; }
    btn && btn.setAttribute('aria-busy', 'true');
    return fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        btn && btn.removeAttribute('aria-busy');
        if (res.status) { throw new Error(res.description || res.message); }
        if (drawer && res.sections) {
          var state = { id: items[0].id, sections: res.sections };
          drawer.classList.contains('is-empty') && drawer.classList.remove('is-empty');
          drawer.renderContents(state);
        } else if (res.sections && res.sections['cart-icon-bubble']) {
          var el = document.getElementById('cart-icon-bubble');
          var doc = new DOMParser().parseFromString(res.sections['cart-icon-bubble'], 'text/html');
          var src = doc.querySelector('.shopify-section');
          if (el && src) el.innerHTML = src.innerHTML;
        }
        document.dispatchEvent(new CustomEvent('orchard:cart-added', { detail: res }));
        return res;
      })
      .catch(function (err) {
        btn && btn.removeAttribute('aria-busy');
        if (btn) { var l = btn.querySelector('[data-o-label]') || btn; var old = l.textContent; l.textContent = (err && err.message) ? err.message.toLowerCase() : 'try again'; setTimeout(function () { l.textContent = old; }, 2400); }
        throw err;
      });
  }
  window.Orchard.cartAdd = cartAdd;

  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-o-add]');
    if (!b || b.hasAttribute('data-o-form')) return;
    e.preventDefault();
    if (b.disabled) return;
    var id = Number(b.dataset.variantId);
    if (!id) return;
    cartAdd([{ id: id, quantity: 1 }], b).then(function () {
      var l = b.querySelector('[data-o-label]') || b;
      var base = b.dataset.label || l.textContent;
      b.dataset.label = base; l.textContent = b.dataset.added || 'added to bag';
      setTimeout(function () { l.textContent = b.dataset.label; }, 2600);
    }).catch(function () {});
  });

  /* ---------- can card single / 4-pack toggle (shop all) ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-o-size]');
    if (!t) return;
    var card = t.closest('[data-o-card]');
    if (!card) return;
    card.querySelectorAll('[data-o-size]').forEach(function (x) { x.setAttribute('aria-pressed', x === t); });
    var isPack = t.dataset.pack === 'true';
    var can = card.querySelector('[data-o-can]'), pack = card.querySelector('[data-o-pack]');
    if (can) can.style.opacity = isPack ? 0 : 1;
    if (pack) pack.style.opacity = isPack ? 1 : 0;
    var price = card.querySelector('[data-o-price]'); if (price) price.textContent = t.dataset.price;
    var add = card.querySelector('[data-o-add]');
    if (add) {
      add.dataset.variantId = t.dataset.variantId;
      var avail = t.dataset.available === 'true';
      add.disabled = !avail; add.classList.toggle('is-soldout', !avail);
      var l = add.querySelector('[data-o-label]') || add;
      l.textContent = avail ? t.dataset.addLabel : 'sold out'; add.dataset.label = l.textContent;
    }
  });

  /* ---------- flipper: crossfade then navigate, prefetch neighbours ---------- */
  /* Touch guard: a finger that moved, or landed while the page was still scrolling (momentum stop), is a scroll, not a tap. */
  var tg = { x: 0, y: 0, moved: false, lastScroll: 0, startedScrolling: false };
  window.addEventListener('scroll', function () { tg.lastScroll = Date.now(); }, { passive: true });
  document.addEventListener('touchstart', function (e) {
    var t = e.touches[0]; tg.x = t.clientX; tg.y = t.clientY; tg.moved = false;
    tg.startedScrolling = Date.now() - tg.lastScroll < 350;
  }, { passive: true, capture: true });
  document.addEventListener('touchend', function (e) {
    var t = e.changedTouches && e.changedTouches[0]; if (!t) return;
    if (Math.abs(t.clientX - tg.x) > 10 || Math.abs(t.clientY - tg.y) > 10) tg.moved = true;
  }, { passive: true, capture: true });
  document.addEventListener('touchmove', function (e) {
    var t = e.touches[0]; if (Math.abs(t.clientX - tg.x) > 10 || Math.abs(t.clientY - tg.y) > 10) tg.moved = true;
  }, { passive: true, capture: true });
  document.addEventListener('click', function (e) {
    var a = e.target.closest('a[href]');
    if (a && e.pointerType !== 'mouse' && (tg.moved || tg.startedScrolling) && e.isTrusted && !a.closest('cart-drawer,.o-drawer')) {
      e.preventDefault(); e.stopPropagation(); tg.moved = false; tg.startedScrolling = false; return;
    }
  }, true);
  document.addEventListener('click', function (e) {
    var a = e.target.closest('[data-o-flip]');
    if (!a || e.metaKey || e.ctrlKey || e.shiftKey) return;
    var main = document.querySelector('[data-o-fade]');
    if (!main || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    e.preventDefault(); main.classList.add('is-out');
    setTimeout(function () { window.location.href = a.href; }, 280);
  });
  window.addEventListener('pageshow', function () { var m = document.querySelector('[data-o-fade]'); m && m.classList.remove('is-out'); });
  document.querySelectorAll('link[data-o-prefetch]').forEach(function () {});

  /* ---------- home flavor tents (400vh sticky scroller) ---------- */
  document.querySelectorAll('[data-o-tents]').forEach(function (sec) {
    var panes = sec.querySelectorAll('[data-o-pane]');
    var n = panes.length; if (!n) return;
    var band = sec.querySelector('[data-o-band]');
    var dots = sec.querySelectorAll('[data-o-dot]');
    var active = -1;
    var items = sec.querySelectorAll('[data-o-i]');
    var mq = window.matchMedia('(max-width:759px)');
    function set(a) {
      if (mq.matches) { if (active !== 'm') { active = 'm'; sec.classList.add('is-ready'); panes.forEach(function (pn) { pn.setAttribute('aria-hidden', 'false'); pn.querySelectorAll('a,button').forEach(function (x) { x.tabIndex = 0; }); }); } return; }
      if (a === active) return; active = a; sec.classList.add('is-ready');
      items.forEach(function (el) {
        var d = Number(el.dataset.oI) - a;
        el.classList.toggle('is-on', d === 0); el.classList.toggle('is-before', d < 0); el.classList.toggle('is-after', d > 0);
        if (el.hasAttribute('data-o-pane')) { el.setAttribute('aria-hidden', d !== 0); el.querySelectorAll('a,button').forEach(function (x) { x.tabIndex = d === 0 ? 0 : -1; }); }
      });
      if (band) band.style.backgroundColor = panes[a].dataset.color;
      dots.forEach(function (d, i) { d.setAttribute('aria-current', i === a); });
    }
    function onScroll() {
      var r = sec.getBoundingClientRect();
      var p = Math.min(0.999, Math.max(0, -r.top / (r.height - window.innerHeight)));
      set(Math.floor(p * n));
    }
    dots.forEach(function (d, i) {
      d.addEventListener('click', function () {
        var top = sec.getBoundingClientRect().top + window.scrollY;
        window.scrollTo({ top: top + (i + 0.5) * (sec.offsetHeight - window.innerHeight) / n, behavior: 'smooth' });
      });
    });
    var tk = false; function onTick() { if (tk) return; tk = true; requestAnimationFrame(function () { tk = false; onScroll(); }); }
    window.addEventListener('scroll', onTick, { passive: true });
    window.addEventListener('resize', onTick);
    onScroll();
  });

  /* ---------- hero load-in ---------- */
  document.querySelectorAll('[data-o-hero]').forEach(function (h) { setTimeout(function () { h.classList.add('is-in'); }, 80); });

  /* ---------- lab results ---------- */
  document.querySelectorAll('[data-o-lab]').forEach(function (lab) {
    var data = []; try { data = JSON.parse(lab.querySelector('[data-o-lab-data]').textContent); } catch (x) {}
    var tabs = lab.querySelectorAll('[data-o-lab-tab]');
    var state = { f: tabs.length ? tabs[0].dataset.handle : '', b: 0 };
    var hash = (location.hash || '').slice(1);
    var qb = (new URLSearchParams(location.search).get('batch') || '').toUpperCase();
    if (qb) { var hb = data.filter(function (d) { return (d.batch || '').toUpperCase() === qb; })[0]; if (hb) hash = hb.flavor; }
    tabs.forEach(function (t) { if (hash && t.dataset.handle.indexOf(hash) > -1) state.f = t.dataset.handle; });
    function rows() { return data.filter(function (d) { return d.flavor === state.f; }); }
    function render() {
      var tab = lab.querySelector('[data-o-lab-tab][data-handle="' + state.f + '"]');
      if (!tab) return;
      tabs.forEach(function (t) { t.setAttribute('aria-pressed', t === tab); });
      ['color', 'tint'].forEach(function (k) { lab.style.setProperty(k === 'color' ? '--fc' : '--tint', tab.dataset[k]); });
      lab.querySelectorAll('[data-o-lab-swirl]').forEach(function (el) { el.style.backgroundImage = 'url(' + tab.dataset.swirl + ')'; });
      lab.querySelectorAll('[data-o-lab-bot]').forEach(function (el) { if (tab.dataset.bot) { el.src = tab.dataset.bot; el.hidden = false; } else el.hidden = true; });
      lab.querySelectorAll('[data-o-lab-can]').forEach(function (el) { if (tab.dataset.can) { el.src = tab.dataset.can; el.hidden = false; el.alt = tab.dataset.name + (tab.dataset.cat === 'beverage' ? ' can' : ''); el.classList.toggle('o-lab__can--pack', tab.dataset.cat !== 'beverage'); } else el.hidden = true; });
      lab.querySelectorAll('[data-o-lab-name]').forEach(function (el) { el.textContent = tab.dataset.name; });
      lab.querySelectorAll('[data-o-lab-short]').forEach(function (el) { el.textContent = tab.dataset.short; });
      lab.querySelectorAll('[data-o-lab-shop]').forEach(function (el) { el.href = tab.dataset.url; });
      var list = rows(); var sel = list[state.b] || null;
      var set = function (sel2, v) { lab.querySelectorAll(sel2).forEach(function (el) { el.textContent = v; }); };
      set('[data-o-lab-label]', sel ? (state.b === 0 ? 'latest batch' : 'archived batch') : 'no batches yet');
      set('[data-o-lab-batch]', sel ? 'batch ' + sel.batch : 'batch reports coming soon');
      var thcTxt = sel && sel.thc ? sel.thc + ' mg' + (sel.unit ? ' ' + sel.unit : '') : '';
      var d9Txt = sel && sel.d9 ? sel.d9 + '%' : '';
      set('[data-o-lab-date]', sel && sel.date ? sel.date : '');
      set('[data-o-lab-thc]', thcTxt);
      set('[data-o-lab-d9]', d9Txt);
      var vals = { date: sel && sel.date, thc: thcTxt, d9: d9Txt, batch: sel && sel.batch, lab: sel && sel.lab };
      lab.querySelectorAll('[data-o-lab-row]').forEach(function (el) { el.hidden = !vals[el.dataset.oLabRow]; });
      var facts = lab.querySelector('[data-o-lab-facts]');
      if (facts) {
        facts.innerHTML = '';
        [['total THC', thcTxt], ['delta-9 THC', d9Txt], ['lab', vals.lab], ['tested', vals.date], ['batch', vals.batch]].forEach(function (f) {
          if (!f[1]) return; var k = document.createElement('span'), v = document.createElement('span'); k.textContent = f[0]; v.textContent = f[1]; facts.appendChild(k); facts.appendChild(v);
        });
      }
      var paper = lab.querySelector('[data-o-lab-paper]'), scan = lab.querySelector('[data-o-lab-scan]'), note = lab.querySelector('[data-o-lab-note]'), open = lab.querySelector('[data-o-lab-open]');
      if (paper) {
        if (sel && sel.pdf) { paper.href = sel.pdf; paper.removeAttribute('aria-disabled'); paper.style.pointerEvents = ''; } else { paper.removeAttribute('href'); paper.style.pointerEvents = 'none'; }
        if (scan) { if (sel && sel.img) { scan.src = sel.img; scan.alt = 'page 1 of the COA for ' + tab.dataset.name + (sel.batch ? ', batch ' + sel.batch : ''); scan.hidden = false; } else { scan.hidden = true; scan.removeAttribute('src'); } }
        if (note) { note.textContent = sel && sel.note ? sel.note : ''; note.hidden = !(sel && sel.note); }
        if (open) open.hidden = !(sel && sel.pdf);
      }
      lab.querySelectorAll('[data-o-lab-size]').forEach(function (el) { el.hidden = !(sel && sel.unit === 'per can'); });
      set('[data-o-lab-b]', sel && sel.batch ? sel.batch : '');
      set('[data-o-lab-lab]', sel && sel.lab ? sel.lab : '');
      lab.querySelectorAll('[data-o-lab-pdf]').forEach(function (el) {
        if (sel && sel.pdf) { el.href = sel.pdf; el.removeAttribute('aria-disabled'); el.hidden = false; } else { el.hidden = true; }
      });
      var box = lab.querySelector('[data-o-lab-rows]');
      if (box) {
        box.innerHTML = '';
        if (!list.length) { box.innerHTML = '<p class="o-lab__empty">Batch reports for this flavor will appear here.</p>'; }
        list.forEach(function (d, i) {
          var b = document.createElement('button'); b.type = 'button'; b.className = 'o-lab__row'; b.setAttribute('aria-pressed', i === state.b);
          b.innerHTML = '<span class="o-lab__rb"></span><span class="o-lab__rd"></span><span class="o-lab__rc"></span>';
          b.children[0].textContent = d.batch; b.children[1].textContent = d.date ? 'tested ' + d.date : '';
          b.children[2].textContent = i === state.b ? 'viewing' : 'view report →';
          b.addEventListener('click', function () { state.b = i; render(); lab.scrollIntoView({ behavior: 'smooth' }); });
          box.appendChild(b);
        });
      }
    }
    tabs.forEach(function (t) { t.addEventListener('click', function () { state.f = t.dataset.handle; state.b = 0; render(); }); });
    var cats = lab.querySelectorAll('[data-o-lab-cat]');
    function showCat(c) {
      cats.forEach(function (b) { b.setAttribute('aria-pressed', b.dataset.oLabCat === c); });
      tabs.forEach(function (t) { t.hidden = cats.length > 0 && t.dataset.cat !== c; });
    }
    cats.forEach(function (b) { b.addEventListener('click', function () {
      showCat(b.dataset.oLabCat);
      var first = lab.querySelector('[data-o-lab-tab][data-cat="' + b.dataset.oLabCat + '"]');
      if (first) { state.f = first.dataset.handle; state.b = 0; render(); }
    }); });
    var _render = render; render = function () { var t = lab.querySelector('[data-o-lab-tab][data-handle="' + state.f + '"]'); if (t && cats.length) showCat(t.dataset.cat); _render(); };
    var form = lab.querySelector('[data-o-lab-find]');
    form && form.addEventListener('submit', function (e) {
      e.preventDefault();
      var q = (form.querySelector('input').value || '').trim().toUpperCase(); if (!q) return;
      var hit = data.findIndex(function (d) { return d.batch.toUpperCase().indexOf(q) > -1; });
      var msg = form.querySelector('[data-o-lab-msg]');
      if (hit < 0) { if (msg) msg.textContent = 'no batch found for ' + q.toLowerCase(); return; }
      if (msg) msg.textContent = '';
      state.f = data[hit].flavor; state.b = rows().indexOf(data[hit]); render();
      var t = lab.querySelector('[data-o-lab-latest]'); t && t.scrollIntoView({ behavior: 'smooth' });
    });
    render();
  });
})();

/* ---------- reviews: real Judge.me reviews in Orchard cards (hidden when none) ---------- */
(function () {
  function esc(s) { var d = document.createElement('div'); d.textContent = s || ''; return d.innerHTML; }
  function stars(n) { var o = ''; for (var i = 1; i <= 5; i++) o += i <= Math.round(n) ? '★' : '☆'; return o; }
  function run(sec) {
    var shop = sec.dataset.shop, tok = sec.dataset.token; if (!shop || !tok) return;
    var hs = (sec.dataset.handles || '').split(',').filter(Boolean), cs = (sec.dataset.colors || '').split(',');
    var grid = sec.querySelector('[data-o-rev-grid]');
    Promise.all(hs.map(function (h, i) {
      return fetch('https://judge.me/api/v1/widgets/product_review?shop_domain=' + encodeURIComponent(shop) + '&api_token=' + encodeURIComponent(tok) + '&handle=' + encodeURIComponent(h) + '&per_page=100')
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (j) {
          if (!j || !j.widget) return [];
          var doc = new DOMParser().parseFromString(j.widget, 'text/html');
          return Array.prototype.map.call(doc.querySelectorAll('.jdgm-rev'), function (el) {
            var c = (cs[i] || '#231F20~#FAF6ED').split('~');
            var sc = el.querySelector('.jdgm-rev__rating'), ts = el.querySelector('.jdgm-rev__timestamp');
            return { score: sc ? Number(sc.getAttribute('data-score')) : 0, author: (el.querySelector('.jdgm-rev__author') || {}).textContent, title: (el.querySelector('.jdgm-rev__title') || {}).textContent, body: (el.querySelector('.jdgm-rev__body') || {}).textContent, product: el.getAttribute('data-product-title'), url: el.getAttribute('data-product-url'), date: ts ? ts.getAttribute('data-content') : '', verified: el.getAttribute('data-verified-buyer') === 'true', fc: c[0], tint: c[1] };
          });
        }).catch(function () { return []; });
    })).then(function (lists) {
      var all = [].concat.apply([], lists);
      if (!all.length) { sec.remove(); return; }
      all.sort(function (a, b) { return (b.date || '').localeCompare(a.date || ''); });
      var single = sec.dataset.single === '1';
      var MO = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
      function fdate(d) { var m = /^(\d{4})-(\d{2})-(\d{2})/.exec(d || ''); return m ? MO[+m[2] - 1] + ' ' + (+m[3]) + ', ' + m[1] : ''; }
      grid.innerHTML = all.map(function (r, i) {
        return '<figure class="o-review-card"' + (single && i > 2 ? ' hidden data-o-rev-more' : '') + ' style="--fc:' + r.fc + ';--tint:' + r.tint + '"><div class="o-stripe"></div>' +
          '<div class="o-review-card__top"><span class="o-stars" aria-label="' + r.score + ' out of 5">' + stars(r.score) + '</span><time>' + esc(fdate(r.date)) + '</time></div>' +
          (r.title && r.title.trim() ? '<b class="o-review-card__title">' + esc(r.title.trim()) + '</b>' : '') +
          '<blockquote class="o-review-card__body">' + esc((r.body || '').trim()) + '</blockquote>' +
          '<button type="button" class="o-review-card__more" hidden aria-expanded="false">read more</button>' +
          '<figcaption class="o-review-card__meta"><span>' + esc((r.author || '').trim()) + (r.verified ? ' · verified' : '') + '</span>' + (single ? '' : '<a href="' + esc(r.url) + '">' + esc((r.product || '').toLowerCase()) + '</a>') + '</figcaption></figure>';
      }).join('');
      if (single && all.length > 3) {
        var btn = document.createElement('button'); btn.type = 'button'; btn.className = 'o-btn o-btn--outline o-review-all'; btn.textContent = 'see all (' + all.length + ')';
        btn.addEventListener('click', function () { grid.querySelectorAll('[data-o-rev-more]').forEach(function (c) { c.hidden = false; }); btn.remove(); checkMore(); });
        grid.after(btn);
      }
      function checkMore() {
        grid.querySelectorAll('.o-review-card:not([hidden])').forEach(function (c) {
          var bd = c.querySelector('.o-review-card__body'), mb = c.querySelector('.o-review-card__more');
          if (!mb.dataset.bound && bd.scrollHeight > bd.clientHeight + 2) {
            mb.hidden = false; mb.dataset.bound = '1';
            mb.addEventListener('click', function () { var o = c.classList.toggle('is-open'); mb.textContent = o ? 'show less' : 'read more'; mb.setAttribute('aria-expanded', o); });
          }
        });
      }
      sec.hidden = false;
      requestAnimationFrame(checkMore);
      var avg = all.reduce(function (s, r) { return s + r.score; }, 0) / all.length;
      var sum = sec.querySelector('[data-o-rev-summary]');
      if (sum) sum.innerHTML = stars(avg) + ' <span style="color:var(--o-ink);letter-spacing:0;font-size:15px">' + avg.toFixed(1) + ' · ' + all.length + ' review' + (all.length === 1 ? '' : 's') + '</span>';
    });
  }
  function init() { document.querySelectorAll('[data-o-reviews]').forEach(run); }
  function later() { (window.requestIdleCallback || function (f) { setTimeout(f, 200); })(init); }
  if (document.readyState === 'complete') later(); else window.addEventListener('load', later);
})();

/* ---------- flavor strips: bring the current tab into view ---------- */
(function () {
  function fit() {
    document.querySelectorAll('.o-flipper__tabs').forEach(function (t) {
      var a = t.querySelector('[aria-current="page"],[aria-current="true"]');
      if (a && t.scrollWidth > t.clientWidth) t.scrollLeft = Math.max(0, a.offsetLeft - t.offsetLeft - 16);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fit); else fit();
})();
